// extracted by mini-css-extract-plugin
var _1 = {"name":"PA-ErrorDisplay"};
var _2 = {"content":"PA-ErrorDisplay__content","reloading":"PA-ErrorDisplay__reloading","nowrapText":"PA-ErrorDisplay__nowrapText"};
var _3 = {};
export { _1 as "b", _2 as "e", _3 as "m" }
